export function LegalPage({ eyebrow, title, updated, testid, children }) {
  return (
    <div className="bg-white" data-testid={testid}>
      <div className="bg-navy grain">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <p className="eyebrow text-gold">{eyebrow}</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-white mt-2">{title}</h1>
          {updated && <p className="mt-3 text-sm text-slate-400">{updated}</p>}
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 legal-content allow-select">
        {children}
      </div>
    </div>
  );
}
